<script>
export default {
  name: "index",
  data() {
    return {
      h:0,
      formData:{
        i:1,
        r:'reposrorder.track',
        shipping_mark:'',//SG-MMJM
        container_num:'',//ZBB-880430552
      },
      error:-1,
      errorTips:'',
      list: [],
      // 图片预览
      previewImgs:[],
      listItemIndex:null,
      nowImgIndex:null,
      transform:'',
      scale:1,
      translate_x:0,
      translate_y:0,
      rotate:0,
      TxtDomOffsetTops:[]
    }
  },
  created() {

  },
  metaInfo() {
    return {
      title: '国际物流轨迹查询', // set a title
    }
  },
  mounted() {
    // window.addEventListener('keyup',this.keyup);
  },
  destroyed() {
    // window.removeEventListener('keyup',this.keyup,false)
  },
  watch: {
    list:{
      handler(newval,oldval) {
        setTimeout(() => {
          if(newval.length>0) {
            let h = document.getElementById('status-name').offsetHeight;
            this.h = parseInt(h);
            this.TxtDomOffsetTops = [];
            newval.forEach((item,index)=>{
              let txt_id = 'txt-'+index;
              let txtOffsetTop = document.querySelector('#'+txt_id).offsetTop;
              this.TxtDomOffsetTops.push(txtOffsetTop);
            });
          }
        },500);
      }
    }
  },
  methods:{
    search() {
      let that = this;
      that.list = [];
      that.error = -1;
      //获取站点信息
      this.$axios({
        url:'/app/uxshop_api.php',
        method:'get',
        params:that.formData,
      }).then(res=>{
        // console.log(res.data);
        // console.log(res)
        that.error=res.data.error;
        if(that.error == 0){
          that.list = res.data.list;
          that.errorTips = '';
        }else {
          that.errorTips = res.data.message;
          that.list = [];
        }
      })
    },
    onmouseenter(e) {
      let data = e.target.dataset;
      this.listItemIndex = data.index;
    },
    // keyup(e) {
    //   console.log(e.code == 'Enter');
    //   if(e.code == 'Enter' ) {
    //     this.search();
    //   }
    // },
    onmouseover(e) {
      let data = e.target.dataset;
      if(data.type === 'image') {
        this.nowImgIndex = data.imgIndex;
      }
    },
    previewImage(e,type) {
      const preview = document.querySelector('#preview-container');
      const preImg = document.querySelector('#image-preview-image');
      if(type == 'open') {
        let imgs = this.list[this.listItemIndex].track_img;
        if(imgs.length>0) {
          this.previewImgs = imgs;
        }
        this.transform = `scale(${this.scale}) translate(${this.translate_x}px,${this.translate_y}px) rotate(${this.rotate}deg)`;
        preview.style.display = 'flex';
        preImg.style.transform = this.transform;
      }else {
        preview.style.display = 'none';
        this.previewImgs = [];
      }
    },
    chonzhi() {
      this.scale=1,
          this.translate_x=0,
          this.translate_y=0,
          this.rotate=0;
      const preImg = document.querySelector('#image-preview-image');
      this.transform = `scale(${this.scale}) translate(${this.translate_x}px,${this.translate_y}px) rotate(${this.rotate}deg)`;
      preImg.style.transform = this.transform;
    },
    pre() {
      if((this.nowImgIndex+1) < this.previewImgs.length) {
        return false;
      }
      this.chonzhi();
      this.nowImgIndex = parseInt(this.nowImgIndex)-1;
    },
    next() {
      if((this.nowImgIndex+1) >= this.previewImgs.length) {
        return false;
      }
      this.chonzhi();
      this.nowImgIndex = parseInt(this.nowImgIndex)+1;
    },
    PreviewOpertion(e) {
      const preImg = document.querySelector('#image-preview-image');
      preImg.style.transform = this.transform;
      let data = e.target.dataset;
      let scale_val = parseFloat(data.maxValue);
      if(data.type === 'jia') {
        this.scale = this.scale +scale_val;
        this.transform = `scale(${this.scale}) translate(${this.translate_x}px,${this.translate_y}px) rotate(${this.rotate}deg)`;
      }
      if(data.type === 'jian' && this.scale > 0.5) {
        this.scale = this.scale - scale_val;
        this.transform = `scale(${this.scale}) translate(${this.translate_x}px,${this.translate_y}px) rotate(${this.rotate}deg)`;
      }
      preImg.style.transform = this.transform;
    },
    showImg(index) {
      const mainContent = document.querySelector('.main-container');
      mainContent.childNodes[index].querySelector('.content').querySelector('#img-box'+index).style.display='flex';
      mainContent.childNodes[index].querySelector('.content').querySelector('.custom-btn').style.display='none';
    }
  }
}
</script>

<template>
  <div class="container" :class="{'flex-start':list.length<=0 && error == -1}">
    <header class="header-container">
      <div class="input-box">
        <div class="li" data-name="唛头">
          <input class="input" v-model="formData.shipping_mark" type="text" placeholder="请输入唛头/Please enter the shipping mark">
        </div>
        <div class="li" data-name="柜号">
          <input class="input" v-model="formData.container_num" type="text" placeholder="请输入柜号/Please enter the cabinet number">
        </div>
      </div>
      <button class="search-btn theme-color-bg" @click="search">查询</button>
    </header>
    <main class="main-container" v-if="list.length>0 && error == 0">
      <div class="li"  style="position: relative" v-for="(item,index) in list" :key="index" :style="'--status-name-h:'+h+'px;--animation-s:'+0.3*index+'s;--animation-s2:'+0.2*index+'s;--txt-offsetTop:'+TxtDomOffsetTops[index]+'px'">
        <div class="status-name" :style="item.color=='black'?'--color:#2a2a2a;--yuan-color:var(--theme-color-bg)':'--color:#999;--yuan-color:#999;'">
          <div id="status-name">
<!--                      top: var(--txt-offsetTop);
-->
            <div class="iconfont icon-lunchuan" style="font-size: 1.8em;" v-if="item.track_status == 'ship'"></div>
            <div v-else-if="item.track_status != 'blank'">{{ item.track_status }}</div>
          </div>
          <div class="line" :class="{'iconfont line-lunchuan':false}" :style="item.track_status == 'ship' || item.track_status == 'blank'?'--yuan-color:transparent;':''"></div>
        </div>
        <div class="content">
<!--          <div @mouseenter="onmouseenter" @mouseover="onmouseover" :data-index="index" class="img-box" v-if="item.track_img">-->
<!--            <div @click="previewImage($event,'open')" class="item" v-for="(img_item,img_index) in item.track_img" :data-type="'image'"  :data-img-index="img_index" :key="img_index">-->
<!--              <img :src="img_item" alt="">-->
<!--            </div>-->
<!--          </div>-->
<!--          <div @mouseenter="onmouseenter" @mouseover="onmouseover" :data-index="index" class="img-box" v-if="index==2">-->
<!--            <div @click="previewImage($event,'open')" class="item" v-for="(img_item,img_index) in 3" :data-type="'image'"  :data-img-index="img_index" :key="img_index">-->
<!--              <img src="https://eye.uxphp.net/uploads/store/comment/20240904/75a0b626f1e62e49ee03d8c8c6a9b9ce.jpg" alt="">-->
<!--            </div>-->
<!--          </div>-->
          <div class="txt" :id="'txt-'+index" style="position: relative">{{item.track_content}}</div>
          <button class="custom-btn btn-16" @click="showImg(index)" v-if="item.track_img">点击查看派件图</button>
          <div @mouseenter="onmouseenter" :id="'img-box'+index" @mouseover="onmouseover" :data-index="index" class="img-box" v-if="item.track_img">
            <div @click="previewImage($event,'open')" class="item" v-for="(img_item,img_index) in item.track_img" :data-type="'image'"  :data-img-index="img_index" :key="img_index">
              <img :src="img_item" alt="">
            </div>
          </div>
          <div class="time">{{ item.track_date }}</div>
        </div>
      </div>
    </main>
    <div v-else-if="error == 0" class="no-data">
      <img style="width: 310px;height: auto;user-select: none" src="~@/assets/image/no-data.png" alt="">
      <div style="color:#b3b3b3;font-size: 0.8em;user-select: none">
        <span>暂无数据</span>
      </div>
    </div>
    <div v-if="error == 1 && list.length<=0" class="no-data">
      <img style="width: 310px;height: auto;user-select: none" src="~@/assets/image/no-data.png" alt="">
      <div style="color:#b3b3b3;font-size: 0.8em;user-select: none">
        <span >{{errorTips}}</span>
      </div>
    </div>
    <div class="footer"> <!--:class="{'footer-fixed-center':list.length<=0 && error == -1}" -->
      <footer class="footer-container">
        <div>{{list.length>0 && error == 0?'Thank you for choosing us to be your shipping companion':'恭喜您成为我们尊贵的客户，期待与您下次再相遇'}}</div>
      </footer>
    </div>
<!--    图片预览-->
    <div id="preview-container">
      <div class="mark" @click="previewImage($event,'close')"></div>
      <div class="image-preview">
        <img class="image-preview-image"  id="image-preview-image" :src="previewImgs[nowImgIndex]" alt="">
      </div>
      <div class="close-btn" @click="previewImage($event,'close')"></div>
      <div class="pre-btn" @click="pre" :style="(nowImgIndex+1) < previewImgs.length?'cursor: no-drop;':'pointer'"></div>
      <div class="next-btn" @click="next" :style="(nowImgIndex+1) >= previewImgs.length?'cursor: no-drop;':'pointer'"></div>
      <div class="preview-opertion">
        <div class="opertion-btn scale-btn_jia" @click="PreviewOpertion($event)" data-type="jia" data-max-value="0.5"></div>
        <div class="opertion-btn scale-btn_jian" @click="PreviewOpertion($event)" data-type="jian" data-max-value="0.5"></div>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
:root {
  --bg-img: url("~@/assets/image/bgImg_m.jpg");
  @media screen and (min-width: 990px){
    --bg-img: url("~@/assets/image/bgImg.jpg");
  }
}
body {
  background-image: var(--bg-img);
  background-size: cover;
  background-repeat: no-repeat;
}
</style>
<style lang="scss" scoped>
@import "~@/assets/iconfont2/iconfont.css";

.container {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  justify-content: center;
  row-gap: 26px;
  transition: justify-content 1s;
  transform: translateY(0);
  @media screen and (min-width: 990px){
    padding: 70px 200px 37px;
  }
  padding: 30px 30px 30px;
  .header-container {
    width: 100%;
    display: flex;
    column-gap: 16px;
    flex-wrap: wrap;
    row-gap: 10px;
    @media screen and (min-width: 990px){
      flex-direction: row;
      align-items: flex-end;
    }
    flex-direction: column;
    .input-box {
      display: flex;
      column-gap: 28px;
      row-gap: 10px;
      flex: 1;
      @media screen and (min-width: 990px){
        flex-direction: row;
      }
      flex-direction: column;
      .li {
        flex: 1;
        height: 100%;
        flex-wrap: wrap;
        position: relative;

        &:before {
          content: attr(data-name);
          display: block;
          margin-bottom: 10px;
          @media screen and (min-width: 990px){
            margin-bottom: 21px;
          }
        }
        .input {
          width: 100%;
          //min-width: 280px;
          border-radius: 10px;
          background-color: #f5f5f5;
          border: none;
          outline: none;
          @media screen and (min-width: 990px){
            padding: 18px 29px;
          }
          padding: 14px 29px;
          &::placeholder {
            color: #999;
          }
        }
      }
    }
    .search-btn {
      flex-shrink: 0;
      @media screen and (min-width: 990px){
        padding: 18px 36px;
      }
      padding: 14px 36px;
      cursor: pointer;
      color: #ffffff;
      border-radius: 10px;
      text-align: center;
      line-height: 100%;
      font-size: 1em;
    }
  }
  .main-container {
    width: 100%;
    padding: 30px 0 50px;
    padding-left: 20px;
    display: flex;
    flex-direction: column;
    row-gap: 50px;
    .li {
      display: flex;
      column-gap: 57px;
      font-size: #333;
      .status-name {
        width: 80px;
        text-align: right;
        font-size: 0.86em;
        flex-shrink: 0;
        position: relative;
        display: flex;
        flex-direction: column;
        color:var(--color);
        #status-name {
          position: relative;
          transition: top 1s;
        }
        .line {
          position: absolute;
          width: 57px;
          height: var(--status-name-h);
          transition: all 0.3s;
          display: flex;
          justify-content: center;
          align-items: center;
          left: 100%;
          //top: var(--txt-offsetTop);
          top: 0;
          z-index: 10;
          &:after {
            content: '';
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background-color: var(--yuan-color);
            display: block;
            opacity: 0;
            animation: show_yuan 0.3s linear var(--animation-s) forwards;
          }
        }
        .line-lunchuan {
          &:before {
            content: '\e669';
            font-size: 1.6em;
            position: absolute;
            opacity: 0;
            z-index: 99;
            bottom: var(--line-height);
            animation: show_yuan 0.3s linear var(--animation-s) forwards;
          }
        }
        &:after {
          content: '';
          width: 2px;
          --line-height:100%;
          //height: calc(var(--line-height) + 50px);
          position: absolute;
          left: calc(100% + 25px + (8px / 2));
          transform: translateX(-30%);
          top: calc(var(--status-name-h) / 2);
          transition: top 0.3s;
          //background-image:radial-gradient(circle at 100%, #333,#eee 75%);
          //background-size: 2px 2px;
          //background-repeat: repeat-y;
          border-left: 2px dotted var(--theme-color);
          animation: fade_start 0.3s linear var(--animation-s) forwards;
        }
        @keyframes fade_start {
          0% {
            height: 0;
          }
          100% {
            height: calc(var(--line-height) + 50px);
          }
        }
        @keyframes show_yuan {
          0% {
            opacity: 0;
          }
          100% {
            opacity: 1;
          }
        }
        @keyframes show_left {
          0% {
            opacity: 1;
            transform: translateX(300%);
          }
          100% {
            opacity: 1;
            transform: translateX(0%);
          }
        }
      }
      .status-name__2 {
        &:after {

        }
      }
      .content {
        opacity: 0;
        animation: show_left 0.3s cubic-bezier(0.3, 0.02, 0, 1.34) var(--animation-s2) forwards;
        .txt {
          font-size: 0.8em;
        }
        .img-box {
          display: none;
          margin-top: 10px;
          flex-wrap: wrap;
          gap: 10px;
          user-select: none;
          .item {
            width: 100px;
            height: 100px;
            padding: 10px;
            //border: 1px dashed #999;
            position: relative;
            img {
              width: 100%;
              height: 100%  ;
              object-fit: contain;
              user-select: none;
            }
            &:after {
              content: '';
              opacity: 0;
              transition: opacity 0.5s;
            }
            &:hover {
              //border-color: var(--theme-color);
              //border-style: solid;
              border: none;
              cursor: pointer;
              position: relative;
              &:after {
                content: '预览';
                text-align: center;
                color: #fff;
                line-height: 100px;
                position: absolute;
                width: 100%;
                height: 100%;
                z-index: 10;
                top: 0;
                left: 0;
                background-color: rgba(0,0,0,.3);
                opacity: 1;
                transition: opacity 0.5s;
              }
            }
          }
        }
        .time {
          font-size: 0.66em;
          margin-top: 16px;
        }
      }
      &:last-child {
        .status-name {
          &:after {
            display: none;
          }
        }
      }
    }
  }
  .footer {
    width: 100%;
  }
  .footer-fixed-center {
    position: fixed;
    top: 50vh;
    box-sizing: border-box;
    left: 0;
    transform: translateY(-50%);
    @media screen and (min-width: 990px){
      padding: 70px 200px 37px;
    }
    padding: 30px 30px 30px;
  }
  .footer-container {
    width: 100%;
    background: #DEE1F0;
    color: #1F2C64;
    font-size: 1em;
    padding: 16px 0;
    text-align: center;
    border-radius: 10px;
    @media screen and (min-width: 990px){
      padding: 20px 0;
    }
  }

}
.no-data {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 100px 0;
  row-gap: 28px;
}
#preview-container {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1000;
  width: 100%;
  height: 100%;
  background-color: rgba(55, 55, 55, .6);
  display: none;
  align-items: center;
  justify-content: center;
  .mark {
    position: relative;
    width: 100%;
    height: 100%;
  }
  .image-preview {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    pointer-events: none;
    .image-preview-image {
      max-width: 70%;
      transition: all 0.3s;
      width: auto;
      object-fit: cover;
      pointer-events: all;
    }
  }
  .pre-btn,.next-btn,.close-btn {
    user-select: none;
    pointer-events: all;
    position: fixed;
    width: 40px;
    height: 40px;
    line-height: 40px;
    border-radius: 50%;
    color: #fff;
    cursor: pointer;
    z-index: 20;
    font-size: 26px;
    background: rgba(55, 55, 55, .4);
    display: flex;
    align-items: center;
    justify-content: center;
    transform: rotate(45deg);
  }
  .pre-btn {
    left: 16px;
    &:before {
      content: '';
      width: 30%;
      height: 30%;
      position: absolute;
      transform: rotate(-90deg) translateX(25%) translateY(25%);
      border-left: 2px solid;
      border-top: 2px solid;
      border-color: #fff;
    }
  }
  .next-btn {
    right: 16px;
    &:before {
      content: '';
      width: 30%;
      height: 30%;
      position: absolute;
      transform: rotate(90deg) translateX(25%) translateY(25%);
      border-left: 2px solid;
      border-top: 2px solid;
      border-color: #fff;
    }
  }
  .close-btn {
    top: 16px;
    right: 16px;
    &:before,
    &:after{
      content: '';
      width: 60%;
      height: 2px;
      background-color: #fff;
      position: absolute;
    }
    &:before{
      width: 2px;
      height: 60%;
      transform: rotate(0deg);
    }
  }
  .preview-opertion {
    pointer-events: all;
    position: fixed;
    top: 46px;
    background: rgba(55, 55, 55, .4);
    border-radius: 100px;
    height: 40px;
    display: flex;
    align-items: center;
    .opertion-btn {
      height: 40px;
      aspect-ratio: 1/1;
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
    }
    .scale-btn_jia,
    .scale-btn_jian{
      cursor: pointer;
      &:before {
        content: '';
        width: 50%;
        height: 2px;
        background-color: #fff;
        border-radius: 100px;
        position: absolute;
      }
      &:after {
        content: '';
        position: absolute;
        width: 2px;
        height: 50%;
        background-color: #fff;
        border-radius: 100px;
      }
    }
    .scale-btn_jian {
      &:after {
        display: none;
      }
    }
  }
}
.flex-start {
  //justify-content: flex-start;
  transform: translateY(-15vh);
}
.custom-btn {
  margin-top: 10px;
  border-radius: 5px;
  padding: 10px 20px;
  font-family: 'Lato', sans-serif;
  font-weight: 500;
  background: transparent;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  font-size: 0.7em;
  display: inline-block;
    box-shadow:inset 2px 2px 2px 0px rgba(255,255,255,.5),
  7px 7px 20px 0px rgba(0,0,0,.1),
  4px 4px 5px 0px rgba(0,0,0,.1);
  outline: none;
}
.btn-16 {
  border: none;
  color: var(--theme-color);
}
.btn-16:after {
  position: absolute;
  content: "";
  width: 0;
  height: 100%;
  top: 0;
  left: 0;
  direction: rtl;
  z-index: -1;
  box-shadow:
      -7px -7px 20px 0px #fff9,
      -4px -4px 5px 0px #fff9,
      7px 7px 20px 0px #0002,
      4px 4px 5px 0px #0001;
  transition: all 0.3s ease;
}
.btn-16:hover {
  color: red;
}
.btn-16:hover:after {
  left: auto;
  right: 0;
  width: 100%;
}
.btn-16:active {
  top: 2px;
}
</style>
